module.exports = __webpack_public_path__ + "img/aeroland-app-showcase-image-02.b364b784.png";